



































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { IAffiliateBrandPayoutDestination } from "@/models/affiliate";
import i18n from "@/i18n";
import {
  IAffiliatePayoutDestinationsProvider,
  IAffiliatePayoutDestinationsMethods
} from "@/models/providers/affiliatePayoutDestinations";

@Component
export default class PayoutDestinationSelect extends Mixins(
  RequestPromises,
  Context
) {
  // Inject
  @Inject({ from: "affiliatePayoutDestinationsProvider" })
  public $affiliatePayoutDestinationsProvider!: () => IAffiliatePayoutDestinationsProvider;

  @Inject({ from: "affiliatePayoutDestinationsProviderMethods" })
  public $affPDMethods!: IAffiliatePayoutDestinationsMethods;

  // Props
  @Prop({ required: true })
  public value;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public preselectDefault!: boolean;

  @Prop({ default: true })
  public injectDefault!: boolean;

  @Prop({ default: null })
  public defaultId!: any;

  @Prop({ default: i18n.t("_.inherit_brand_default") })
  public defaultLabel!: string;

  @Prop({ default: true })
  public showBrandDefault!: any;

  @Prop({ default: "id" })
  public selectField!: string;

  // Data
  public injectedDestination: IAffiliateBrandPayoutDestination[] = [];
  public dataScope!: string;
  public dataModule: string = DataModules.AFFILIATES_PAYOUT_DESTINATIONS;

  public preSelected: string | number = "";

  // Life-cycle hooks
  public async created() {
    this.tryInjectDefault();
    this.trySelectDefault();
  }

  // Computed
  public get affPDData() {
    return this.$affiliatePayoutDestinationsProvider();
  }

  public get selected() {
    return this.value;
  }

  public set selected(selected) {
    this.$emit("input", selected);
  }

  public get payoutDestinations() {
    return this.affPDData.payoutDestinations;
  }

  public get payoutDestinationsMap() {
    return [...this.injectedDestination, ...this.payoutDestinations];
  }

  // Methods
  public getSelectedDestination(id) {
    return this.payoutDestinationsMap.find(i => i.id === id);
  }

  public tryInjectDefault() {
    if (this.injectDefault) {
      this.injectedDestination.push({
        id: this.defaultId,
        name: this.defaultLabel
      } as IAffiliateBrandPayoutDestination);
    }
  }

  public trySelectDefault() {
    if (!this.preselectDefault || this.value) return;
    const defaultItem = this.payoutDestinations.find(i => i.default);
    if (defaultItem) this.selected = defaultItem?.id;
  }
}
